
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefoasis/contact-us",
      function () {
        return require("private-next-pages/debtreliefoasis/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefoasis/contact-us"])
      });
    }
  